module.exports = __webpack_public_path__ + "static/media/default-alt.1d9f0e21.png";